/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { accountSettings, card } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const MONAVATE_CARD_STATUS = 'card.monavate.status';
export const GALILEO_STATUS = 'card.galileo.status';
export const USA_CARD_GET_STATUS = 'card.galileo.usa_card_get_status';
export const USA_CARD_GET_IMAGE = 'card.galileo.usa_card_get_image';
export const USA_CARD_GET_BALANCE = 'card.galileo.balance';
export const USA_CARD_GET_PIN = 'card.galileo.pin';
export const USA_GET_LAST_TRANSACTIONS = 'card.galileo.lastTransaction';

export const CARD_INTEREST_PAYMENT_CRYPTODRAFT = 'card.cryptodraft.interestPayment';
export const CARD_CRYPTODRAFT = 'card.cryptodraft.details';
export const CARD_CRYPTODRAFT_SETTLEMENT = 'card.cryptodraft.settlementInfo';
export const CARD_LINKED_WALLETS = 'card.wallets.linkedWallets';
export const CARD_LINKABLE_WALLETS = 'card.wallets.linkableWallets';
export const CARD_CRYPTODRAFT_WITHDRAWABLE = 'card.cryptodraft.withdrawable';

export const MASTERCARD_MONAVATE_DETAILS = 'card.monavate.details';

export const ORDERABLE_CARD_TYPES = 'card.payment.orderable';
export const MONAVATE_CARD_BALANCE = 'card.monavate.balance';
export const CONNECT_FINANCIAL_CARD_STATUS = 'card.connectFinancial.status';
export const CONNECT_FINANCIAL_CARD_BALANCE = 'card.connectFinancial.balance';
export const CONNECT_FINANCIAL_CARD_ORDER_STATUS = 'card.connectFinancial.orderStatus';
export const CONNECT_FINANCIAL_CARD_DETAILS_PAGE = 'card.connectFinancial.detailsPage';

export const CARD_TRANSACTION_FUNDING_SOURCES = 'card.transaction.fundingSources';

export const CARD_SCA_GET_NOTIFICATIONS = 'card.sca.getNotifications';
export const CARD_SCA_VERIFY_OTP = 'card.sca.verifyOtp';
export const CARD_LOAD_CASHBACK = 'card.load.cashback';
export const CARD_MONAVATE_PIN = 'card.monavate.viewPin';
export const CARD_MONAVATE_PIN_CHECK = 'card.monavate.checkPin';

queryClient.setQueryDefaults(CARD_TRANSACTION_FUNDING_SOURCES, {
  queryFn: ({ queryKey }) => card.fundingSources(queryKey),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_MONAVATE_PIN, {
  queryFn: ({ queryKey }) => card.monavate.viewPin(queryKey[1]),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_MONAVATE_PIN_CHECK, {
  queryFn: () => card.monavate.checkPIN(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(MASTERCARD_MONAVATE_DETAILS, {
  queryFn: ({ queryKey }) => card.monavate.viewDetails(queryKey[1]),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(MONAVATE_CARD_STATUS, {
  queryFn: () => card.monavate.status(),
  onError: (error) => {
    handleError(error);
  },
  refetchOnMount: true,
  staleTime: 0,
  cacheTime: 0,
});

queryClient.setQueryDefaults(GALILEO_STATUS, {
  queryFn: () => card.galileo.status(),
  onError: (error) => {
    handleError(error);
  },
  refetchOnMount: true,
  staleTime: 0,
  cacheTime: 0,
});

queryClient.setQueryDefaults(CONNECT_FINANCIAL_CARD_STATUS, {
  queryFn: () => card.connectFinancial.status(),
  onError: (error) => {
    handleError(error);
  },
  refetchOnMount: true,
  staleTime: 0,
  cacheTime: 0,
});

queryClient.setQueryDefaults(CONNECT_FINANCIAL_CARD_BALANCE, {
  queryFn: async () => ({ balance: 0 }),
});

queryClient.setQueryDefaults(CONNECT_FINANCIAL_CARD_ORDER_STATUS, {
  queryFn: () => card.connectFinancial.orderStatus(),
  onError: (error) => {
    handleError(error);
  },
  staleTime: 0,
  cacheTime: 0,
});

queryClient.setQueryDefaults(CONNECT_FINANCIAL_CARD_DETAILS_PAGE, {
  queryFn: card.connectFinancial.detailsPage,
  onError: (error) => {
    handleError(error);
  },
  staleTime: 0,
  cacheTime: 0,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

queryClient.setQueryDefaults(MONAVATE_CARD_BALANCE, {
  queryFn: () => card.monavate.balance(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(USA_CARD_GET_BALANCE, {
  queryFn: () => card.galileo.balance(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(USA_CARD_GET_PIN, {
  queryFn: ({ queryKey }) => card.galileo.viewPin(queryKey[1]),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_INTEREST_PAYMENT_CRYPTODRAFT, {
  queryFn: () => card.cryptodraft.interestPayment(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_CRYPTODRAFT, {
  queryFn: () => card.cryptodraft.details(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_CRYPTODRAFT_SETTLEMENT, {
  queryFn: () => card.cryptodraft.getFullSettlementInfo(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_LINKED_WALLETS, {
  queryFn: () => card.wallets.linkedWallets(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_LINKABLE_WALLETS, {
  queryFn: () => card.wallets.linkableWallets(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_CRYPTODRAFT_WITHDRAWABLE, {
  queryFn: () => card.cryptodraft.getWithdrawableAmount(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(ORDERABLE_CARD_TYPES, {
  queryFn: () => card.payment.orderableCardTypes(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(CARD_SCA_GET_NOTIFICATIONS, {
  queryFn: card.sca.getNotifications,
});

queryClient.setQueryDefaults(CARD_SCA_VERIFY_OTP, {
  queryFn: ({ otpCode, scaNotificationId }) =>
    card.sca.verifyOtp({
      otp_code: otpCode,
      sca_notification_id: scaNotificationId,
    }),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(USA_CARD_GET_IMAGE, {
  queryFn: card.galileo.usCardImage,
});

queryClient.setQueryDefaults(USA_CARD_GET_STATUS, {
  queryFn: () => card.galileo.status(),
  onError: (error) => {
    handleError(error);
  },
  refetchOnMount: true,
  staleTime: 0,
  cacheTime: 0,
});

queryClient.setQueryDefaults(CARD_LOAD_CASHBACK, {
  queryFn: accountSettings.getRewardCashbackCurrency,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(USA_GET_LAST_TRANSACTIONS, {
  queryFn: card.galileo.lastTransactions,
  onError: (error) => {
    handleError(error);
  },
});
